
import { mapState } from 'vuex'
import { useDispatchStoreAction } from '~/mixins/DispatchStoreAction'

export default {
  mixins: [
    useDispatchStoreAction({
      action: 'user/register',
      errorTextKey: 'registration-failed',
    }),
  ],

  props: {
    isTeacher: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      register: {
        is_teacher: this.isTeacher,
        address_type: 'private',
        no_street_number: false,
      },

      hasSubmitted: false,

      addressTypeOptions: [
        {
          key: 'private',
          label: this.$t('address-type-private'),
        },
        {
          key: 'business',
          label: this.$t('address-type-business'),
        },
      ],
    }
  },

  computed: {
    ...mapState('global', ['loginPageSettings', 'registrationSettings']),
    salutationOptions() {
      return Object.entries(
        this.$i18n.messages[this.$i18n.locale].salutations
      ).map(([key, label]) => ({
        key,
        label,
      }))
    },

    countryOptions() {
      return Object.entries(
        this.$i18n.messages[this.$i18n.locale].countries
      ).map(([key, label]) => ({
        key,
        label,
      }))
    },
  },

  methods: {
    async onSubmit() {
      this.hasSubmitted = true

      const isValid = await this.$refs.observer.validate()
      if (!isValid) {
        return
      }

      if (this.storeAction.state === 'loading') {
        return
      }

      this.$toast.show(this.$t('process-registration'))
      try {
        await this.dispatchStoreAction(this.register, {
          silentOnSuccess: true,
        })

        this.$emit('registered', this.register)
      } catch (error) {}
    },
  },
}
